// We use this fetchData function, instead of fetch

import { ConflictError, UnauthorizedError } from "../errors/http_errors";

const BACKEND_URL = "https://notes-api-ttsn.onrender.com";

// so that we can handle different HTTP errors better
export const fetchData = async (input: RequestInfo, init?: RequestInit) => {
  const apiEndpoint = BACKEND_URL + input;

  const response = await fetch(apiEndpoint, init);
  if (response.ok) {
    return response;
  } else {
    const errorBody = await response.json();
    const { error: errorMessage } = errorBody;

    if (response.status === 401) {
      throw new UnauthorizedError(errorMessage);
    } else if (response.status === 409) {
      throw new ConflictError(errorMessage);
    } else {
      throw Error(
        "Request failed with status : " +
          response.status +
          " message: " +
          errorMessage
      );
    }
  }
};
